import type { ReactNode } from 'react'
import { Button } from '../Button/Button'
import { chips, controls, resultCount as resultCountClass, root } from './FilterToolbar.css'

export type FilterToolbarProps = {
  children: ReactNode
  chips?: ReactNode
  resultCount?: ReactNode
  onClear?: () => void
  'data-testid'?: string
}

export function FilterToolbar({
  children,
  chips: chipsNode,
  resultCount,
  onClear,
  'data-testid': testId,
}: FilterToolbarProps) {
  const hasChipsRow = chipsNode != null || onClear != null || resultCount != null

  return (
    <div className={root} data-testid={testId}>
      <div className={controls}>{children}</div>
      {hasChipsRow ? (
        <div className={chips}>
          {chipsNode}
          {onClear ? (
            <Button variant="text" size="sm" onClick={onClear}>
              Limpar
            </Button>
          ) : null}
          {resultCount != null ? <span className={resultCountClass}>{resultCount}</span> : null}
        </div>
      ) : null}
    </div>
  )
}
